import { getFirebase } from 'react-redux-firebase';

export const uploadFile = (firebase, storagePath, dataPath, file) => firebase.uploadFile(storagePath, file).then((res) => {
  const { uploadTaskSnaphot: { downloadURL = {}, metadata: { name, fullPath } } = {} } = res;
  return firebase.updateWithMeta(dataPath, {
    downloadURL,
    name,
    fullPath,
  });
});

export const getFileDownloadUrl = async (path) => {
  const storage = getFirebase().storage();
  return storage.ref(path).getDownloadURL();
};



// WEBPACK FOOTER //
// ./src/helpers/fileHelpers.js